import { koComponent } from '../../ko-utils';
import * as siteConfig from '../../site-config/config';

class BackdropDescriptor {
    constructor(params) {
        this.root = params.rootElement;
        this.onChange = params.onChange;

        if (!this.root()) {
            this.root(new siteConfig.BackdropDescriptor());
        }

        this.types = [
            { text: 'None', val: undefined, css: 'far fa-times-circle' },

            { text: 'Blocking', val: 'blocking', css: 'fas fa-hand-pointer' },

            { text: 'Darkened', val: 'transparent', css: 'far fa-square' },
            //{ text: 'Solid', val: 'solid', css: 'fas fa-square' },

            { text: 'Box', val: 'boxed_noblock', css: 'far fa-square' },
            { text: 'Box & Blocking', val: 'boxed', css: 'fas fa-expand' },
            { text: 'Box, Blocking & Darkened', val: 'boxed_bg', css: 'fas fa-square' },

            { text: 'Glow', val: 'glow', css: 'far fa-sun' },
            { text: 'Glow & Blocking', val: 'glow_block', css: 'fas fa-sun' },
        ];

        const parAvailable = ko.unwrap(params.availableTypes);

        this.availableTypes = parAvailable ? this.types.filter(i => parAvailable.indexOf(i.val) !== -1) : [];
    }

    onValueChanged(item) {
        this.root().type(item.val);

        if (this.onChange) {
            this.onChange();
        }
    }
}

export default koComponent('backdrop-descriptor', BackdropDescriptor);